import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=68b8ad94&scoped=true&lang=scss"
script.__scopeId = "data-v-68b8ad94"

export default script